exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.extra-savings[data-v-141847df] {\n  padding-top: 0.5em;\n  font-size: 0.8em;\n}\n.v-sub[data-v-141847df] {\n  vertical-align: sub;\n}\n.price[data-v-141847df] {\n  font-size: 3.5em;\n}\n.br-all[data-v-141847df] {\n  border-radius: 20px;\n}\n.savings-banner[data-v-141847df] {\n  border-radius: 20px 20px 0 0;\n  margin: 0 -1px;\n}\n.bs-custom[data-v-141847df] {\n  -webkit-box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.2);\n          box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.2);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-141847df","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SummaryCard.vue
// module id = 617
// module chunks = 0